import React from 'react'
import _ from 'underscore'
import { Button } from '@/components/ui/button'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import Modal from '../modal'
import store from '../../state/store'

const TEXTAREA_CLASSES = 'block w-full rounded border border-border bg-card px-3 py-2 text-sm text-foreground leading-snug focus:border-primary focus:outline-none'

class CompletePlacement extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      note: '',
      reason: '',
      cancel_note: '',
      complete_conceal_job_ad: false,
      cancel_conceal_job_ad: false
    }
  }

  onClose = () => {
    store.emit('ui:complete_placement:close')
  }

  onComplete = () => {
    store.emit('placement_request:complete', { note: this.state.note, conceal_job_ad: this.state.complete_conceal_job_ad })
  }

  onCancel = () => {
    store.emit('placement_request:cancel', { reason: this.state.reason, note: this.state.cancel_note, conceal_job_ad: this.state.cancel_conceal_job_ad })
  }

  render() {
    const { cancellation_reasons } = this.props.ui.complete_placement

    return (
      <Modal title="Complete Placement" subtitle="Finalise this tutor placement." size="modal-lg" onClose={this.onClose}>
        <div className="p-6 text-left">
          <Tabs defaultValue="complete">
            <TabsList>
              <TabsTrigger value="complete">Complete</TabsTrigger>
              <TabsTrigger value="cancel">Cancel</TabsTrigger>
            </TabsList>

            <TabsContent value="complete">
              <div className="grid gap-2 pt-4">
                <textarea
                  className={TEXTAREA_CLASSES}
                  rows={3}
                  placeholder="Handover note (required)…"
                  value={this.state.note}
                  onChange={(e) => this.setState({ note: e.target.value })}
                />
                <div className="flex items-center gap-2">
                  <Checkbox
                    id="complete_conceal_job_ad"
                    checked={this.state.complete_conceal_job_ad}
                    onCheckedChange={(checked) => this.setState({ complete_conceal_job_ad: checked === true })}
                  />
                  <Label htmlFor="complete_conceal_job_ad" className="text-sm font-normal">
                    Turn off the Job Ad
                  </Label>
                </div>
                <div className="flex justify-end">
                  <Button variant="success" size="sm" disabled={!this.state.note.trim()} onClick={this.onComplete}>
                    Complete Placement
                  </Button>
                </div>
              </div>
            </TabsContent>

            <TabsContent value="cancel">
              <div className="grid gap-2 pt-4">
                <Select value={this.state.reason || undefined} onValueChange={(value) => this.setState({ reason: value })}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select a reason…"/>
                  </SelectTrigger>
                  <SelectContent>
                    {_.map(cancellation_reasons, (reason) => (
                      <SelectItem key={reason.value} value={reason.value}>{reason.name}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                <textarea
                  className={TEXTAREA_CLASSES}
                  rows={2}
                  placeholder="Note (optional)…"
                  value={this.state.cancel_note}
                  onChange={(e) => this.setState({ cancel_note: e.target.value })}
                />
                <div className="flex items-center gap-2">
                  <Checkbox
                    id="cancel_conceal_job_ad"
                    checked={this.state.cancel_conceal_job_ad}
                    onCheckedChange={(checked) => this.setState({ cancel_conceal_job_ad: checked === true })}
                  />
                  <Label htmlFor="cancel_conceal_job_ad" className="text-sm font-normal">
                    Turn off the Job Ad
                  </Label>
                </div>
                <div className="flex justify-end">
                  <Button variant="destructive" size="sm" disabled={!this.state.reason} onClick={this.onCancel}>
                    Cancel Placement
                  </Button>
                </div>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </Modal>
    )
  }
}

export default CompletePlacement
